import React, {useEffect} from "react";
import {Col, DatePicker, Form, Image, Input, Row} from "antd";
import {useStore} from "../../../store";
import moment from "moment/moment";
import {BaseImageUrl} from "../../../http/http";
import styled from "styled-components";

const defaultIcon = require("../../../image/default-pic.png")

const DnaDetail:React.FC = () => {
    const [form] = Form.useForm();
    const {dnaLibraryStore} = useStore();
    useEffect(() => {
        const {detailEntity} = dnaLibraryStore;
        const detail = JSON.parse(JSON.stringify(detailEntity));
        if (detail && detail.sequenceTime) {
            detail.sequenceTime = moment(detail.sequenceTime)
        }
        form.setFieldsValue(detail);
    }, [])
    return (<Wrapper>
        <Form disabled={true} labelAlign={"right"} wrapperCol={{span: "15"}} title={"图谱库"} form={form}
              layout={"horizontal"} size={"middle"} style={{maxHeight: "400px", overflow: "auto"}}>
            <Row justify={"space-between"} gutter={[15, 15]}>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"序列编号"} name={"sequenceNumber"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"采样编号"} name={"sampleNumber"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"药材名"} name={"medicineName"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"基原植物"} name={"originalPlant"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"拉丁名"} name={"latinName"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"样品来源"} name={"sampleSource"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"取样部位"} name={"smapleLocation"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"样品提供单位"} name={"sampleUnit"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"鉴定人"} name={"appraiser"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"责任人"} name={"dutyPerson"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"序列提交时间"} name={"sequenceTime"}
                                          required={false}><DatePicker/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"序列类型"} name={"sequenceType"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"采集信息"} name={"collectInfo"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span: "8"}} label={"描述信息"} name={"describeInfo"}
                                          required={false}><Input/></Form.Item></Col>
                <Col span={12}>
                    <Form.Item label={"图片:"} required={false} labelCol={{span: "8"}}>
                        <Image preview={false} src={BaseImageUrl + dnaLibraryStore.detailEntity?.imgUrl}
                               fallback={defaultIcon}/>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    </Wrapper>);
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  overflow: scroll;
`;
export default DnaDetail;